import { render, staticRenderFns } from "./NewLegal.vue?vue&type=template&id=7f77438c&"
import script from "./NewLegal.vue?vue&type=script&lang=js&"
export * from "./NewLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports